import { createFileRoute, notFound } from '@tanstack/react-router';

import LandingPage from '@/pages/landing/LandingPage';
import { withCompareLettingAgentsHeading } from '@/pages/landing/utils/compare-letting-agents-heading';
import { getFooterLandingPages, getLandingPage } from '@/sanity/landing-page';
import { getLegalLinks } from '@/sanity/legal-document';
import { getLandingPageFaqs } from '@/utils/landing-page-faqs';
import {
  buildBreadcrumbSchema,
  buildFaqPageSchema,
  buildPageMeta,
  buildStructuredDataScript,
} from '@/utils/seo';

export const Route = createFileRoute('/$slug')({
  loader: async ({ params }) => {
    const [landingPage, footerLandingPages, footerLegalLinks] =
      await Promise.all([
        getLandingPage({ data: params.slug }),
        getFooterLandingPages(),
        getLegalLinks(),
      ]);
    if (!landingPage) {
      throw notFound();
    }

    const page = withCompareLettingAgentsHeading(params.slug, landingPage);

    return {
      footerLandingPages,
      footerLegalLinks,
      landingPage: page,
    };
  },
  component: LandingPage,
  head: ({ loaderData, params }) => {
    const pageMeta = buildPageMeta({
      title: loaderData?.landingPage.seoTitle ?? 'Budgy',
      description:
        loaderData?.landingPage.seoDescription ??
        'Compare local letting agents with Budgy.',
      path: `/${encodeURIComponent(params.slug)}`,
    });
    const faqs = getLandingPageFaqs(loaderData?.landingPage);
    const breadcrumbSchema = buildStructuredDataScript(
      buildBreadcrumbSchema([
        { name: 'Home', path: '/' },
        {
          name: loaderData?.landingPage.hero.title ?? 'Budgy',
          path: `/${encodeURIComponent(params.slug)}`,
        },
      ]),
    );

    return {
      ...pageMeta,
      scripts: [
        breadcrumbSchema,
        ...(faqs.length > 0
          ? [buildStructuredDataScript(buildFaqPageSchema(faqs))]
          : []),
      ],
    };
  },
});
